import { Grid, media, spacing } from '@lamimed/pantheon';
import styled from 'styled-components';

export const Wrapper = styled(Grid.Wrapper)`
  display: flex;
  flex-direction: column;

  ${media.greaterThan('tablet')`
    display: flex;
    flex-direction: row;
    align-items: start;
    padding-left: ${spacing.medium};
  `};
`;
